// extracted by mini-css-extract-plugin
export default {"container":"detail_container__PwRus","text":"detail_text__+wosi","btn":"detail_btn__ZT8nF","activate":"detail_activate__0+41V","deactivate":"detail_deactivate__gD6hH"};